import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t py-6 md:py-0">
      <div className="container flex flex-col items-center gap-4 md:h-16 md:flex-row md:justify-between">
        <div className="flex flex-col items-center gap-4 px-8 md:flex-row md:gap-2 md:px-0">
          <p className="text-center text-sm leading-loose text-muted-foreground md:text-left">
            Built by{" "}
            <a
              href="https://mon10.org"
              target="_blank"
              rel="noreferrer"
              className="font-medium underline underline-offset-4"
            >
              mon10
            </a>
            . For any inquiries or issues,{" "}
            <a
              href="mailto:abdullah@meetzi.app"
              className="font-medium underline underline-offset-4"
            >
              contact us here
            </a>
            .
          </p>
        </div>
        <div className="flex items-center gap-4">
          <a
            href="https://www.instagram.com/habitualy.app/"
            target="_blank"
            rel="noreferrer"
            className="text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Follow us on Instagram"
          >
            <Instagram className="h-5 w-5" />
          </a>
          <Link
            to="/pomodoro"
            className="text-sm text-muted-foreground underline-offset-4 hover:underline"
          >
            Pomodoro Timer
          </Link>
          <Link
            to="/blog"
            className="text-sm text-muted-foreground underline-offset-4 hover:underline"
          >
            Blog
          </Link>
          <Link
            to="/privacy"
            className="text-sm text-muted-foreground underline-offset-4 hover:underline"
          >
            Privacy
          </Link>
          <Link
            to="/terms"
            className="text-sm text-muted-foreground underline-offset-4 hover:underline"
          >
            Terms
          </Link>
        </div>
      </div>
    </footer>
  );
} 